import { createAsyncThunk } from "@reduxjs/toolkit";
import { SEARCH_URL } from "../../utils/topic-endpoints";

export const getImageSearchData = createAsyncThunk(
  "searchResults/getImageSearchData",
  async (query, { rejectWithValue }) => {
    const url = SEARCH_URL + `&query=${query}`;
    const response = await fetch(url);
    const data = await response.json();

    if (!response.ok) {
      return rejectWithValue("Images not found");
    }
    return {
      searchQuery: query,
      searchResults: data,
    };
  }
);
